import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, NgZone, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfigService } from './app/services/config.service';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

// APP_INITIALIZER um Config vor App-Start zu laden
function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'de' },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    },
  ],
})
  .then((ref) => {
    // Test-Hook: nur unter Cypress aktiv. Erlaubt E2E-Tests, Server-seitige
    // WebSocket-Events innerhalb von NgZone einzuspielen, sodass Angulars
    // Change-Detection danach läuft. Im normalen Browser-Betrieb passiert
    // hier nichts (kein `window.Cypress`).
    const w = window as unknown as { Cypress?: unknown; __smNgZone?: NgZone };
    if (w.Cypress) {
      w.__smNgZone = ref.injector.get(NgZone);
    }
  })
  .catch((err) => console.error(err));

